<div class="section-fullscreen bg-header coming-soon">
    <div class="container text-center">
        <div class="position-top">
            <div class="row align-items-center g-0">
                <div class="col-6 text-start">
                    <h3 class="uppercase letter-spacing-1 logo"><a routerLink="/">Delex</a></h3>
                </div>
                <div class="col-6 text-end">
                    <ul class="list-inline">
                        <li><a href="#"><i class="bi bi-facebook"></i></a></li>
                        <li><a href="#"><i class="bi bi-twitter-x"></i></a></li>
                        <li><a href="#"><i class="bi bi-linkedin"></i></a></li>
                    </ul>
                </div>
            </div><!-- end row -->
        </div><!-- end position-top -->
        <div class="position-middle">
            <div class="row">
                <div class="col-12">
                    <h1 class="display-4 fw-lighter mb-4">We're Coming Soon</h1>
                    <h1 class="countdown">
                        <span>{{ timeLeft.days }} days {{ formatTwoDigits(timeLeft.hours) }}:{{ formatTwoDigits(timeLeft.minutes) }}:{{ formatTwoDigits(timeLeft.seconds) }}</span>
                    </h1>
                </div>
            </div><!-- end row -->
        </div><!-- end position-middle -->
        <div class="position-bottom">
            <p>&copy; 2026 Delex. All Rights Reserved. Designed by <a href="https://themeforest.net/user/designsninja" target="_blank">DesignsNinja</a></p>
        </div><!-- end position-bottom -->
    </div><!-- end container -->
</div>